<script setup lang="ts">
import BaseModal from '@/components/modal/BaseModal.vue';
import ModalFooterConfirmButtons from '@/components/modal/ModalFooterConfirmButtons.vue';
import { MODAL_TYPES, QnaDeleteModalProps, useModalStore } from '@/stores/modal';
import { ref } from 'vue';

const props = defineProps<QnaDeleteModalProps>();
const modalStore = useModalStore();
const isSubmitting = ref(false);
const errorMsg = ref('');

const handleCancel = () => {
  modalStore.close(MODAL_TYPES.QNA_DELETE);
};

const handleConfirm = async () => {
  isSubmitting.value = true;
  errorMsg.value = '';
  try {
    const result = await props.onConfirm();
    if (result.success) {
      modalStore.close(MODAL_TYPES.QNA_DELETE);
    } else {
      errorMsg.value = result.error || '문의 삭제 중 오류가 발생했습니다.';
    }
  } catch (error) {
    errorMsg.value = error instanceof Error ? error.message : '문의 삭제 중 오류가 발생했습니다.';
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<template>
  <BaseModal title="문의 삭제" width="360px" @close="handleCancel">
    <div class="px-5 py-4">
      <p class="text-[16px] text-[#404040] text-center leading-6">
        정말 삭제하시겠습니까?<br />
        삭제된 문의는 복구할 수 없습니다.
      </p>
      <div v-if="props.majorCat || props.subCat" class="mt-3 text-center text-[13px] text-[#757575]">
        {{ [props.majorCat, props.subCat].filter(Boolean).join(' / ') }}
      </div>
      <div v-if="errorMsg" class="mt-3 text-[13px] text-primary-500 text-center">
        {{ errorMsg }}
      </div>
    </div>
    <template #footer>
      <ModalFooterConfirmButtons
        confirm-text="삭제"
        cancel-text="취소"
        :disabled="isSubmitting"
        :is-loading="isSubmitting"
        @confirm="handleConfirm"
        @cancel="handleCancel"
      />
    </template>
  </BaseModal>
</template>

